import React, { Component } from 'react';
import { connect } from "react-redux";
import { debounce } from "lodash";
import { constants } from '../../Helpers/Constants';
import { setBookingsDb, setProfileDb, setReturnReleaseBookings } from '../../Actions/dataActions';
import { setList, setOverlay, configureBookingDictionary, openPullout } from '../../Actions/stakeholderActions';

import axios from "axios";
import moment from "moment";
import { ActionApproveUser, ActionRejectUser, EditAction } from '../Common/Buttons/Icons';

//A React component will allow us to quickly iterate and change our code. It provides 
class ApproveRejectComponent extends Component {
    constructor(props) {
        super(props);

        this.onApproveHandler = debounce(this.onApproveHandler.bind(this), 500);
        this.onRejectHandler = this.onRejectHandler.bind(this);
    }

    onApproveHandler(e, props) {
        e.stopPropagation();
        var self = this;

        if("datatoggle" in this.props)
        {
            this.toggleDropdown();
        }

        axios.post('/ajax/' + (this.props.type == "booking" ? "booking" : "profile") + '/' + props.id + '/approve')
        .then((response) => {
            if (props.type === "booking") {
                axios.get('/ajax/booking/' + props.id)
                .then(function(response2) {
                    self.props.dispatch(setBookingsDb([response2.data.booking], props.data.bookings_db))
                })
                .catch(function(error) {
                    if(error.response?.status == 401){
                        showStatusMsg(error.response?.data.error);
                    } else if(error.response?.status == 422) {
                        var error_message = "";
    
                        $.each(error.response?.data.errors, function (index, element) {
                            error_message += element + '<br />';
                        });
    
                        showStatusMsg(error_message);
                    } else {
                        showStatusMsg("Requested information not found");
                    }
                })
                if (self.props.match.url.split("/")[1] === "bookings" || self.props.match.url.split("/")[1] === "home") {
                    var data = { search_term: $("#searchbar").val(),
                                vmh: $("input[name='vmh[]']:checked").map(function () { return this.value; }).get().join('#'), 
                                sh: $("input[name='sh[]']:checked").map(function () { return this.value; }).get().join('#'),
                                start_date: self.props.stakeholder.current_date.clone().subtract(3, 'weeks'),
                                end_date: self.props.stakeholder.current_date.clone().add(3, 'weeks')
                            }
                            
                    if (self.props.stakeholder.booking_next_page !== null && self.props.stakeholder.booking_next_page > 0) {
                        data['grab_all_pages'] = self.props.stakeholder.booking_next_page;
                    }
                    
                    axios({
                        method: 'post',
                        url: '/ajax/calendar/bookings',
                        data: data
                    })
                    .then(function(response2) {
                        self.props.dispatch(setList("SET_CURRENT_BOOKINGS_LIST", response2.data.bookings_list));
                        self.props.dispatch(configureBookingDictionary(response2.data.bookings_list, response2.data.holidays, self.props.stakeholder.organized_bookings))
                        self.props.dispatch(setList("SET_BOOKING_REQUEST_LIST", response2.data.pending_bookings));
                        self.props.dispatch(setReturnReleaseBookings(response2.data.return_release_bookings));
                    })
                    .catch(function(error) {
                        if(error.response?.status == 401){
                            showStatusMsg(error.response?.data.error);
                        } else if(error.response?.status == 422) {
                            var error_message = "";
            
                            $.each(error.response?.data.errors, function (index, element) {
                                error_message += element + '<br />';
                            });
            
                            showStatusMsg(error_message);
                        } else {
                            showStatusMsg("Requested information not found");
                        }
                    })
                }

                if ("vehicle" in props.stakeholder.current_vehicle_details && props.booking.V_ID === props.stakeholder.current_vehicle_details.vehicle.V_ID) {
                    axios.get('/ajax/vehicle/' + props.booking.V_ID)
                    .then(function(response2) {
                        props.dispatch(setOverlay("SET_CURRENT_VEHICLE_DETAILS", response2.data))
                    })
                    .catch(function(error) {
                        if(error.response?.status == 401){
                            showStatusMsg(error.response?.data.error);
                        } else if(error.response?.status == 422) {
                            var error_message = "";
        
                            $.each(error.response?.data.errors, function (index, element) {
                                error_message += element + '<br />';
                            });
        
                            showStatusMsg(error_message);
                        } else {
                            showStatusMsg("Requested information not found");
                        }
                    })
                }
    
                if ("profile" in props.stakeholder.current_profile_details && props.booking.Profile_ID === props.stakeholder.current_profile_details.profile.ID) {
                    axios.get('/ajax/profile/' + props.booking.Profile_ID)
                    .then(function(response2) {
                        props.dispatch(setOverlay("SET_CURRENT_PROFILE_DETAILS", response2.data))
                    })
                    .catch(function(error) {
                        if(error.response?.status == 401){
                            showStatusMsg(error.response?.data.error);
                        } else if(error.response?.status == 422) {
                            var error_message = "";
        
                            $.each(error.response?.data.errors, function (index, element) {
                                error_message += element + '<br />';
                            });
        
                            showStatusMsg(error_message);
                        } else {
                            showStatusMsg("Requested information not found");
                        }
                    })
                }

                showStatusMsg(response?.data.message, 'success')
            } else {
                var data = {};

                if(self.props.match.url.split("/")[1] === "useroverview") {
                    var data = {
                        search_term: self.props.stakeholder.previous_filters.search,
                        sort_filter: self.props.stakeholder.sort_filter,
                        sort_direction: self.props.stakeholder.sort_direction,
                        bookings_min: self.props.stakeholder.previous_filters.bookings.min,
                        bookings_max: self.props.stakeholder.previous_filters.bookings.max,
                        last_booking_min: self.props.stakeholder.previous_filters.last_booking.min,
                        last_booking_max: self.props.stakeholder.previous_filters.last_booking.max,
                        member_min: self.props.stakeholder.previous_filters.member.min,
                        member_max: self.props.stakeholder.previous_filters.member.max
                    }
    
    
                    var filters = self.props.stakeholder.previous_filters;
                    var categories = Object.keys(filters);
                    for (var i = 0; i < categories.length; i++) {
                        data[categories[i]] = "";
                        if (categories[i] !== "bookings" || categories[i] !== "last_booking" || categories[i] !== "member") {
                            var items = Object.keys(filters[categories[i]]);
                            for (var k = 0; k < items.length; k++) {
                                if (filters[categories[i]][items[k]] === true) {
                                    if (data[categories[i]] === "") {
                                        data[categories[i]] = items[k]
                                    } else {
                                        data[categories[i]] = data[categories[i]] + "#" + items[k]
                                    }
                                }
                            }
                        }
                    }
                }

                axios({
                    method: 'post',
                    url: '/ajax/user_list/update',
                    data: data
                })
                .then(function(response2) {
                    props.dispatch(setProfileDb(response2.data.customers, props.data.profile_db));
                    props.dispatch(setList("SET_USER_LIST", response2.data.customers))
                })
                .catch(function(error) {
                    if(error.response?.status == 401){
                        showStatusMsg(error.response?.data.error);
                    } else if(error.response?.status == 422) {
                        var error_message = "";
    
                        $.each(error.response?.data.errors, function (index, element) {
                            error_message += element + '<br />';
                        });
    
                        showStatusMsg(error_message);
                    } else {
                        showStatusMsg("Requested information not found");
                    }
                })

                axios({
                    method: 'get',
                    url: '/ajax/dashboard/pendingusers',
                })
                .then(function(response2) {
                    props.dispatch(setList("SET_USER_REQUEST_LIST", response2.data.invites))
                })
                .catch(function(error) {
                    if(error.response?.status == 401){
                        showStatusMsg(error.response?.data.error);
                    } else if(error.response?.status == 422) {
                        var error_message = "";
    
                        $.each(error.response?.data.errors, function (index, element) {
                            error_message += element + '<br />';
                        });
    
                        showStatusMsg(error_message);
                    } else {
                        showStatusMsg("Requested information not found");
                    }
                })
            }

            showStatusMsg(response?.data.message, 'success');
        })
        .catch(function(error) {
            if(error.response?.status == 401){
                showStatusMsg(error.response?.data.error);
            } else if(error.response?.status == 422) {
                var error_message = "";

                $.each(error.response?.data.errors, function (index, element) {
                    error_message += element + '<br />';
                });

                showStatusMsg(error_message);
            } else {
                showStatusMsg("Requested information not found");
            }
        })
        //props.onApproveHandler(e, props);
    }

    onRejectHandler(e, props) {
        e.stopPropagation();
        if("datatoggle" in this.props)
        {
            this.toggleDropdown();
        }

        this.props.history.push(this.props.match.url + '/reject' + (this.props.type == "booking" ? "booking" : "user") + '/' + props.id);
        //props.onRejectHandler(e, props);
    }

    onEditHandler(e, props) { //only used for bookings
        e.stopPropagation();
        // this.props.dispatch(openPullout(props.booking, "edit"));
        axios.get('/ajax/booking/' + props.booking.BOOK_ID)
        .then((response) => {
            props.dispatch(openPullout(
                {
                    vehicle: response?.data.vehicle, 
                    ...response?.data.booking
                }, "edit"))
        }).catch((err) => {
            throw new Error("Couldn't edit that booking");
        })
    }

    toggleDropdown() {
        const  element = document.getElementById(this.props.datatoggle);
        if (!element) return;

        element.classList.toggle('is-open');
    }

    render() {
        if (this.props.userSession.user.has_booking_access) {
            return (
                <div className = "button-group" style={{cursor: 'default'}}>
                    <a className = "action-button no-margin float-right mr-2" onClick={(e) => {this.onApproveHandler(e, this.props)}} style={{cursor: 'pointer'}}>
                        {ActionApproveUser()}
                    </a>
                    <a className = "action-button no-margin float-right mr-2" onClick={(e) => {this.onRejectHandler(e, this.props)}} style={{cursor: 'pointer'}}>
                        {ActionRejectUser()}
                    </a>
                    {this.props.type === "booking" ? 
                        <a className = "action-button no-margin float-right" onClick={(e) => {this.onEditHandler(e, this.props)}} style={{cursor: 'pointer'}}>
                            {EditAction()}
                        </a>
                    : null }
                    
                </div>
            )
        } else {
            return (
                <div />
            )
        }
    }
}

const mapStateToProps = store => ({
    userSession: store.userSession,
    data: store.data,
    stakeholder: store.stakeholder
});

export default connect(mapStateToProps)(ApproveRejectComponent);